import React, { useState, useEffect, useRef } from 'react';
import careersHeroBackground from '../../Assets/Images/Careers/careersbg2.jpg';
import lifeAtGs1 from '../../Assets/Images/LifeAtGS/UVP00009 copy 2.jpg';
import lifeAtGs2 from '../../Assets/Images/LifeAtGS/UVP00030 copy.jpg';
import lifeAtGs3 from '../../Assets/Images/LifeAtGS/UVP00026 copy.jpg';
import lifeAtGs4 from '../../Assets/Images/LifeAtGS/UVP00034 copy.jpg';
import lifeAtGs5 from '../../Assets/Images/LifeAtGS/UVP00025 copy 2.jpg';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import innovation from "../../Assets/Images/Careers/innovation.png";
import growth from "../../Assets/Images/Careers/growth.png";
import collaborative from "../../Assets/Images/Careers/collaborative.png";
import realimpact from "../../Assets/Images/Careers/realimpact.png";
import work from "../../Assets/Images/Careers/teamwork.png";
import prespective from "../../Assets/Images/Careers/perspective.png"

import video2 from '../../Assets/Images/vedioTest/Vaishnavi Koban (5).mp4';
import video5 from '../../Assets/Images/vedioTest/Sakshi Pote (2) (1) (1).mp4';
import video6 from '../../Assets/Images/vedioTest/Siddhi Mhaske (7) (1) (1).mp4';
import video8 from '../../Assets/Images/vedioTest/Vaibhavi Nighvekar (1) (1).mp4';


import { API_BASE_URL } from '../../config';
import uploadImg from "../../Assets/Images/Careers/folder1.png"
import bin from "../../Assets/Images/Careers/delete.png"
import "../../Assets/CSS/Styles.scss";
import SuccessModal from "../../Componants/Models/SuccessModal";
const Careers = () => {
  //job opening
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/jobs`);
        setJobs(res.data.data);
      } catch (err) {
        console.error("Error fetching jobs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []); // no need to depend on adminToken


  const [formData, setFormData] = useState({
    fullName: '',
    mobileNumber: '',
    emailAddress: '',
    message: '',
    position: ''
  });
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({
    fullName: '',
    mobileNumber: '',
    emailAddress: '',
    message: '',
    resume: ''
  });

  const [uploadState, setUploadState] = useState("idle");
  // idle | uploading | done

  const [uploadProgress, setUploadProgress] = useState(0);
  const fileInputRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    isError: false
  });
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email) && (email.endsWith('.com') || email.endsWith('.org') ||
      email.endsWith('.net') || email.endsWith('.edu') || email.endsWith('.in'));
  };

  const validateMobile = (mobile) => {
    const re = /^\d{10}$/;
    return re.test(mobile);
  };

  const validateFile = (file) => {
    if (!file) return false;

    const validTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",

      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp"
    ];

    return validTypes.includes(file.type) && file.size <= 5 * 1024 * 1024;
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      fullName: '',
      mobileNumber: '',
      emailAddress: '',
      message: '',
      position: '',
      resume: ''
    };

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required";
      valid = false;
    } else if (!/^[A-Za-z\s]+$/.test(formData.fullName.trim())) {
      newErrors.fullName = "Full Name should only contain letters and spaces";
      valid = false;
    } else if (formData.fullName.trim().length < 2) {
      newErrors.fullName = "Full Name must be at least 2 characters long";
      valid = false;
    }

    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = 'Mobile Number is required';
      valid = false;
    } else if (!validateMobile(formData.mobileNumber)) {
      newErrors.mobileNumber = 'Please enter a valid 10-digit mobile number';
      valid = false;
    }

    if (!formData.emailAddress.trim()) {
      newErrors.emailAddress = 'Email is required';
      valid = false;
    } else if (!validateEmail(formData.emailAddress)) {
      newErrors.emailAddress = 'Please enter a valid email address (e.g. example@gmail.com)';
      valid = false;
    }

    if (!formData.position.trim()) {
      newErrors.position = "Position is required";
      valid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Please tell us about yourself';
      valid = false;
    }

    if (!file) {
      newErrors.resume = 'Resume is required';
      valid = false;
    } else if (!validateFile(file)) {
      newErrors.resume = 'Please upload PDF, Word, or Image file (max 5MB)';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));

    if (errors[id]) {
      setErrors(prev => ({ ...prev, [id]: '' }));
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (!validateFile(selectedFile)) {
      setErrors(prev => ({
        ...prev,
        resume: "Please upload PDF, Word, or Image file (max 5MB)"
      }));
      return;
    }

    setErrors(prev => ({ ...prev, resume: "" }));
    setFile(selectedFile);

    // Start Upload UI
    setUploadState("uploading");
    setUploadProgress(0);

    // Simulate Progress (You can replace with real axios progress)
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);

      if (progress >= 100) {
        clearInterval(interval);
        setUploadState("done");
      }
    }, 200);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const data = new FormData();
    data.append("fullName", formData.fullName);
    data.append("mobileNumber", formData.mobileNumber);
    data.append("emailAddress", formData.emailAddress);
    data.append("message", formData.message);
    data.append("position", formData.position);
    data.append("resume", file);

    try {
      await axios.post(`${API_BASE_URL}/api/getintouch`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      // ✅ Show Success Modal
      setModalData({
        title: "Your Application Has Been Received!",
        message: "Your details have been successfully received. We appreciate your interest and will contact you shortly.",
        isError: false
      });


      setShowModal(true);

      // Reset Form
      setFormData({
        fullName: "",
        mobileNumber: "",
        emailAddress: "",
        message: ""
      });

      setFile(null);
      setUploadState("idle");
      setUploadProgress(0);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

    } catch (err) {
      console.error(err);

      // ❌ Show Error Modal
      setModalData({
        title: "Error",
        message: err.response?.data?.message || "Failed to submit the form. Please try again.",
        isError: true
      });

      setShowModal(true);
    }
  };

  // --- State for "Life at Global Solutions" Carousel ---
  const lifeAtGsImages = [
    lifeAtGs1,
    lifeAtGs2,
    lifeAtGs3,
    lifeAtGs4,
    lifeAtGs5,
  ];

  const responsiveLifeAtGs = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  // --- State for "Employee Testimonials" Carousel ---
  const testimonials = [

    {
      name: "Vaishnavi Koban",
      position: "UI-UX Designer",
      video: video2,
    },
    {
      name: "Sakshi Pote",
      position: "Software Tester",
      video: video5,
    },
    {
      name: "Siddhi Mhaske",
      position: "Frontend Developer",
      video: video6,
    },

    {
      name: "Vaibhavi Nighvekar",
      position: "HR",
      video: video8,
    },

  ];

  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const videoRef = useRef(null);

  const currentTestimonial = testimonials[testimonialIndex];

  const nextTestimonial = () => {
    setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setTestimonialIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  // ✅ On testimonial change, just reload video (no autoplay)
  useEffect(() => {
    if (!videoRef.current) return;
    videoRef.current.pause();
    videoRef.current.load(); // Load new video, user must click play
  }, [testimonialIndex]);

  // --- Data for "Why Work at Global Solutions?" Section ---
  const whyWorkReasons = [
    {
      logo: innovation,
      title: "Innovative Culture",
      description: "We work on cutting-edge ERP, SaaS, and cloud solutions for institutions nationwide.",
    },
    {
      logo: growth,
      title: "Growth & Learning",
      description: "Mentorship, training, and real project ownership from day one.",
    },
    {
      logo: collaborative,
      title: "Collaborative Team",
      description: "Designers, developers, marketers — all growing together.",
    },
    {
      logo: realimpact,
      title: "Real Impact",
      description: "Help transform education systems across cities and regions.",
    },
    {
      logo: prespective,
      title: "Inclusive Environment",
      description: "We value every voice and welcome diverse perspectives.",
    },
    {
      logo: work,
      title: "Purpose-Driven Work",
      description: "Every project contributes to making education more accessible and efficient.",
    },
  ];


  return (
    <div className="careers_container font-sans antialiased text-gray-800 mt60 ">
      {/* Hero Section */}
      <section
        className="relative h-[500px] md:h-[488px] flex items-center justify-center p-2 overflow-hidden py-10 bg-gray-50 text-white"
      >
        <div
          className="absolute inset-0 bg-center bg-cover"
          style={{ backgroundImage: `url(${careersHeroBackground})` }}
        ></div>
        {/* Overlay for darkening the image */}
        <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-[3px] z-10"></div>

        {/* Content */}
        <div className="relative z-20 text-center max-w-2xl mx-auto px-4">
          {/* <p className="text-sm font-medium mb-4 uppercase tracking-wider">
            👋 We're Hiring Amazing Talent
          </p> */}
          <div className="inline-flex items-center px-3 py-1 mb-4 text-sm font-medium text-black bg-[#ffdd9d] rounded-full">

            <p className="text-sm font-medium uppercase tracking-wider">
              👋 We're Hiring Amazing Talent
            </p>
          </div>


          <h1 className="font-heading font-bold-500 text-white text-2xl md:text-4xl lg:text-5xl mb-6 leading-tight">

            Join the Team Building the <span className="font-heading font-bold-500 mt-10 text-[#FBBF24]"> Future of Education Tech </span>
          </h1>
          <p className="font-ui text-white text-md leading-6 mt-6 mb-8 p">
            At Global Solutions, we're redefining how institutions operate through smart, scalable digital solutions.
          </p>


          <a
            href="#open-positions"
            className="block mx-auto mt-8 text-[15px] demo-button font-bold font-ui flex items-center gap-2 w-48 py-2 rounded-lg bg-[#F59E0B]  hover:bg-[#f3b541] justify-center"
          >
            View Open Roles
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </a>
        </div>
      </section>

      {/* Why Work at Global Solutions? Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="font-heading mb-4 text-[25px] font-bold color: #111827">
              Why Work at Global Solutions?
            </h2>
            <p className="text-center text-[15px] mb-2 color: #374151 font-ui">
              Join a team that's passionate about transforming education through technology
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {whyWorkReasons.map((reason, index) => (
              <div
                key={reason.id || index} // 👈 add a unique key here
                className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-300 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg"
              >
                {/* Circular Icon - Positioned at top center overlapping the border */}
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 ">
                  <div className="flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 border-2 border-white shadow-md">
                    <img
                      src={reason.logo}
                      alt={reason.title}
                      className="w-8 h-8 object-contain"
                    />
                  </div>
                </div>

                <div className="mt-5">
                  <h3 className="text-[25px] font-heading font-bold text-[#111827] mb-2">
                    {reason.title}
                  </h3>
                  <p className="text-[15px] mb-2 text-[#374151] font-ui">
                    {reason.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Open Positions Section */}
      <section id="open-positions" className="py-16 bg-[#F8F9FA]">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="font-heading mb-4 text-[25px] font-bold text-[#111827]">
              Open Positions
            </h2>
            <p className="text-center text-[15px] mb-2 text-[#374151] font-ui">
              Find your next opportunity to make a difference in education
            </p>
          </div>

          {loading ? (
            <p className="text-center text-gray-500">Loading jobs...</p>
          ) : jobs.length === 0 ? (
            <p className="text-center text-gray-500">No jobs available at the moment.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {jobs.map((job) => (
                <Link
                  to={`/careers/${job._id}`} // Pass job ID to detail page
                  key={job._id}
                  className="block bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105"
                >
                  <div className="inline-block px-3 py-1 rounded-full text-sm font-medium mb-4 bg-orange-100 text-orange-800">
                    {job.department || "General"}
                  </div>
                  <h3 className="text-xl font-bold text-[#111827] mb-2">
                    {job.position}
                  </h3>
                  <div className="flex items-center text-gray-600 text-sm mb-2">
                    <span className="mr-1">📍</span>
                    {job.workMode}
                  </div>
                  <div className="flex items-center text-gray-600 text-sm mb-2">
                    <span className="mr-1">💼</span>
                    {job.workType}
                  </div>
                  <div className="flex items-center text-gray-600 text-sm mb-4">
                    <span className="mr-1">⏳</span>
                    {job.experience}
                  </div>
                  <p className="text-[15px] mb-2 text-[#374151] font-ui">
                    {job.overview.split(" ").slice(0, 20).join(" ") +
                      (job.overview.split(" ").length > 20 ? "..." : "")}
                  </p>

                  <div className="text-blue-800 font-semibold flex items-center gap-1">
                    View Details ➜
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Life at Global Solutions Section (Carousel) */}
      <div className="w-full max-w-4xl mx-auto px-4 lg:px-0 relative">
        <h2 className="font-heading mb-8 text-[25px] font-bold text-center text-[#111827] mt-16">
          Life at Global Solutions
        </h2>

        {/* Carousel */}
        <Carousel
          responsive={responsiveLifeAtGs}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={3500}
          transitionDuration={600}
          containerClass="carousel-container"
          itemClass="flex justify-center px-2 sm:px-4"   // ✅ Center items
          arrows={true}
          showDots={false}
          pauseOnHover={true}
          draggable={true}
          swipeable={true}
          keyBoardControl={true}
        >
          {lifeAtGsImages.map((image, index) => (

            <img
              src={image}
              alt={`Life at Global Solutions ${index + 1}`}
              className="w-full h-full object-cover rounded-lg shadow-lg transition-transform duration-500 ease-in-out hover:scale-105 border-2 border-[#F59E0B]"
            />
            // </div>
          ))}
        </Carousel>
      </div>

      {/* Video */}
      <section className="py-16 bg-[#F8F9FA]">
        <div className="container mx-auto px-6 max-w-3xl">
          <div className="relative bg-white p-8 md:p-12 rounded-xl shadow-lg border border-gray-200 text-center">

            {/* Star Rating */}
            <div className="flex justify-center mb-4">
              {[...Array(5)].map((_, i) => (
                <svg
                  key={i}
                  className={`w-6 h-6 transition-colors duration-300 ${i < 5 ? "text-yellow-400 fill-current" : "text-gray-300"
                    }`}
                  viewBox="0 0 24 24"
                >
                  <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.241L12 18.295l-7.416 3.978 1.48-8.241L0 9.306l8.332-1.151z" />
                </svg>
              ))}
            </div>

            {/* Video */}
            <div className="mb-8 relative z-10">
              <video
                key={testimonialIndex}
                ref={videoRef}
                className="w-full h-auto rounded-lg shadow-md"
                controls
              >
                <source src={currentTestimonial.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            {/* Name and Position */}
            <p className="font-bold text-[#111827] text-lg">
              {currentTestimonial.name}
            </p>
            <p className="text-gray-600 text-sm">
              {currentTestimonial.position}
            </p>

            {/* Navigation Arrows */}
            <button
              onClick={prevTestimonial}
              className="absolute top-1/2 left-4 -translate-y-1/2 p-2 rounded-full bg-white shadow-md text-gray-700 hover:bg-gray-200 focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>
            <button
              onClick={nextTestimonial}
              className="absolute top-1/2 right-4 -translate-y-1/2 p-2 rounded-full bg-white shadow-md text-gray-700 hover:bg-gray-200 focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Didn't Find a Role That Fits? Section */}
      <section className="bg-blue-900 text-white py-16">
        <div className="container mx-auto px-6 max-w-5xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Section: Didn't Find a Role That Fits? */}
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold mb-4">Didn't Find a Role That Fits?</h2>

              <p className=" font-ui text-white text-md mb-6 ">
                We're always looking for curious minds and passionate individuals. Send us your resume and let's explore opportunities together.
              </p>
              <ul className="space-y-3 mb-8 font-ui text-white text-md ">
                <li className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-[#FFA500]" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.45 16.35a1 1 0 01-1.4-1.4l-3-3a1 1 0 011.4-1.4l2.3 2.3 4.3-4.3a1 1 0 011.4 1.4l-5 5a1 1 0 01-.7.3zm-.45 6.65a10 10 0 100-20 10 10 0 000 20z" clipRule="evenodd" />
                  </svg>
                  We review every application personally
                </li>
                <li className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-[#FFA500]" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.45 16.35a1 1 0 01-1.4-1.4l-3-3a1 1 0 011.4-1.4l2.3 2.3 4.3-4.3a1 1 0 011.4 1.4l-5 5a1 1 0 01-.7.3zm-.45 6.65a10 10 0 100-20 10 10 0 000 20z" clipRule="evenodd" />
                  </svg>
                  Quick response within 48 hours
                </li>
                <li className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-[#FFA500]" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.45 16.35a1 1 0 01-1.4-1.4l-3-3a1 1 0 011.4-1.4l2.3 2.3 4.3-4.3a1 1 0 011.4 1.4l-5 5a1 1 0 01-.7.3zm-.45 6.65a10 10 0 100-20 10 10 0 000 20z" clipRule="evenodd" />
                  </svg>
                  Opportunities across all departments
                </li>
              </ul>
              <button className="bg-[#faa913] px-6 py-3 font-bold rounded-lg demo-button hover:bg-[#e69500] text-[15px] font-ui flex items-center gap-2">
                Send Your Resume
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </button>
            </div>

            {/* Right Section: Get in Touch Form */}

            <div className="getintouch-card">
              <h2 className="form-title">Get in Touch</h2>

              <form onSubmit={handleSubmit} className="form-wrapper">

                {/* Full Name */}
                <div className="floating-group">
                  <input
                    type="text"
                    id="fullName"
                    name='fullName'
                    placeholder=" "
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                  <label htmlFor="fullName">Full Name *</label>
                  {errors.fullName && <p className="form-error">{errors.fullName}</p>}
                </div>

                {/* Mobile */}
                <div className="floating-group">
                  <input
                    type="tel"
                    id="mobileNumber"
                    placeholder=" "
                    value={formData.mobileNumber}
                    onChange={handleChange}
                  />
                  <label htmlFor="mobileNumber">Mobile Number *</label>
                  {errors.mobileNumber && <p className="form-error">{errors.mobileNumber}</p>}
                </div>

                {/* Email */}
                <div className="floating-group">
                  <input
                    type="email"
                    id="emailAddress"
                    placeholder=" "
                    value={formData.emailAddress}
                    onChange={handleChange}
                  />
                  <label htmlFor="emailAddress">Email Address *</label>
                  {errors.emailAddress && <p className="form-error">{errors.emailAddress}</p>}
                </div>

                <div className="floating-group">
                  <input
                    type="text"
                    id="position"
                    placeholder=" "
                    value={formData.position}
                    onChange={handleChange}
                  />
                  <label htmlFor="position">Position Applying For *</label>
                  {errors.position && <p className="form-error">{errors.position}</p>}
                </div>

                {/* Message */}
                <div className="floating-group">
                  <textarea
                    id="message"
                    rows="4"
                    placeholder=" "
                    value={formData.message}
                    onChange={handleChange}
                  />
                  <label htmlFor="message">Tell us about yourself *</label>
                  {errors.message && <p className="form-error">{errors.message}</p>}
                </div>

                {/* File Upload */}
                {/* File Upload Section */}
                <div className="modern-upload-wrapper">

                  {uploadState === "idle" && (
                    <label htmlFor="resume" className="upload-box">
                      <input
                        ref={fileInputRef}
                        type="file"
                        id="resume"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                        onChange={handleFileChange}

                      />
                      <div className="upload-content">
                        <div className="upload-icon">
                          <img src={uploadImg} className='uploadfile' />
                        </div>
                        <h4  >Drop file here</h4>
                        <p>Support for single upload. PDF, DOC, DOCX, JPG, PNG (Max 5MB)</p>
                      </div>
                    </label>
                  )}

                  {uploadState === "uploading" && (
                    <div className="upload-box uploading">
                      <div className="progress-circle">
                        <div
                          className="circle"
                          style={{ "--progress": uploadProgress }}
                        >
                          <span>{uploadProgress}%</span>
                        </div>

                      </div>
                      <p>Uploading files...</p>
                    </div>
                  )}

                  {uploadState === "done" && file && (
                    <div className="uploaded-file-card">
                      <div className="file-info">
                        <div className="file-icon">📄</div>
                        <div>
                          <h5>{file.name}</h5>
                          <p>{(file.size / 1024).toFixed(2)} KB</p>
                        </div>
                      </div>

                      <div className="file-actions">
                        <span className="success-check">✔</span>
                        <div>
                          <img className='binimg' src={bin}
                            onClick={() => {
                              setFile(null);
                              setUploadState("idle");
                              setUploadProgress(0);

                              if (fileInputRef.current) {
                                fileInputRef.current.value = "";
                              }
                            }}

                          />
                        </div>

                      </div>
                    </div>
                  )}

                  {errors.resume && <p className="form-error">{errors.resume}</p>}
                </div>
                {/* Submit Button */}
                <button type="submit" className="submit-btn">
                  Send Message →
                </button>

              </form>
            </div>

          </div>
          <SuccessModal
            show={showModal}
            handleClose={() => setShowModal(false)}
            title={modalData.title}
            message={modalData.message}
            isError={modalData.isError}
          />
        </div>
      </section>
    </div>
  );
};

export default Careers;